export const ProjectMilestone = {
  _list: function() {
    
    jQuery('.milestone-container').on('click', '.delete-milestone', function(e) {
      if (confirm(jQuery(this).attr('data-confirm'))) {
        jQuery.post(jQuery(this).attr('href'), function(d) {
          if (d.status) {
            jQuery('#modal-dialog', top.document).modal('hide');
            top.Turbo.visit(top.location.href);
          }
        });
      }

      e.preventDefault();
      return false;
    });
  }
}